import React, { useState, useEffect } from 'react';

export const PaginationControls: React.FC<{
  currentPage: number;
  totalPages: number;
  startIndex: number;
  endIndex: number;
  totalItems: number;
  onPageChange: (page: number) => void;
}> = ({ currentPage, totalPages, startIndex, endIndex, totalItems, onPageChange }) => {
  const [pageInput, setPageInput] = useState((currentPage + 1).toString());

  useEffect(() => {
    setPageInput((currentPage + 1).toString());
  }, [currentPage]);

  return (
    <>
      <div className="dvc-pagination-controls">
        <div className="dvc-pagination-buttons">
          <button onClick={() => onPageChange(0)} disabled={currentPage === 0}>
            ⏮️ First
          </button>
          <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 0}>
            ⏪ Previous
          </button>
        </div>
        <div className="dvc-pagination-info">
          <span>
            Page {currentPage + 1} of {totalPages}
          </span>
          <span className="dvc-pagination-count">
            ({startIndex + 1}-{endIndex} of {totalItems})
          </span>
        </div>
        <div className="dvc-pagination-buttons">
          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage >= totalPages - 1}
          >
            Next ⏩
          </button>
          <button
            onClick={() => onPageChange(totalPages - 1)}
            disabled={currentPage >= totalPages - 1}
          >
            Last ⏭️
          </button>
        </div>
      </div>
      <div className="dvc-page-jump">
        <label>Go to page:</label>
        <input
          type="number"
          min={1}
          max={totalPages}
          value={pageInput}
          onChange={(e) => setPageInput(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              const page = parseInt(pageInput, 10) - 1;
              if (page >= 0 && page < totalPages) onPageChange(page);
            }
          }}
        />
        <button
          onClick={() => {
            const page = parseInt(pageInput, 10) - 1;
            if (page >= 0 && page < totalPages) onPageChange(page);
          }}
        >
          Go
        </button>
      </div>
      <div className="dvc-pagination-footer">
        Showing {startIndex + 1}-{endIndex} of {totalItems} images. Click to select, Shift+click for
        range, Double-click to view.
      </div>
    </>
  );
};
